export default class RailsEnv {
  static isDev() {
    return this.isEnv('development');
  }

  static isTest() {
    return this.isEnv('test');
  }

  static isStaging() {
    return this.isEnv('staging');
  }

  static isProduction() {
    return this.isEnv('production');
  }

  static isEnv(env) {
    return this.getEnv() === env;
  }

  static getEnv() {
    if (!window.ENV) return 'unknown';

    return window.ENV && window.ENV.environment;
  }
}
